import { CLIENT_ERROR_MESSAGE_MAX, CLIENT_ERROR_STACK_MAX, routes } from '@spot/shared';

import type { ApiClient } from './api';

let sent = false;

/**
 * Sends one crash per page load to the own error log (T-1101). Best effort: never retried and
 * never throws. The API scrubs it; only the path is sent (no query string or hash).
 */
export function reportCrash(api: ApiClient, error: unknown): void {
	if (sent) return;
	sent = true;
	const err = error instanceof Error ? error : new Error(typeof error);
	api
		.call(routes.clientError, {
			body: {
				name: err.name.slice(0, 100) || 'Error',
				message: err.message.slice(0, CLIENT_ERROR_MESSAGE_MAX),
				...(err.stack === undefined ? {} : { stack: err.stack.slice(0, CLIENT_ERROR_STACK_MAX) }),
				path: window.location.pathname.slice(0, 200),
			},
		})
		.catch(() => undefined);
}

/** Test hook: allow another report. */
export function resetCrashReport(): void {
	sent = false;
}
